/**
 * @file 账户信息
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {get, map, pick} from 'lodash';
import {isAder} from '@/common/utils';

export default class ARServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';

    formData = {
        id: '',
        appId: '',
        name: '',
        status: '',
        aderName: '',
        submitType: 'save'
    };

    serviceType = 'ar';

    aderList = [];

    appListDatasource = [];

    stepsInfo = {
        data: [],
        current: 1
    };

    /**
    * @override
    */
    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {
            text: '新建AR服务'
        }
    ];

    isMaterial = false;

    init() {
        super.init();

        this.getAppList = this.api.appList;
        this.getAderList = this.api.aderList;

        if (this.pageType === 'create') {
            this.createRequester = this.api.appServiceARCreate;
        }
        else {
            this.detailRequester = this.api.appServiceARDetail;
            if (this.pageType === 'copy') {
                this.updateRequester = this.api.appServiceARCreate;
            }
            else {
                this.updateRequester = this.api.appServiceARUpdate;
            }
        }
        // 设置 stepsData 和 crumbData
        this.setCrumbData();
        this.isAder = isAder(this.getDev());
        this.stepsInfo = this.getStepsData();
        this.id = this.getRouteParams().serviceId;
        this.formData.appId = this.getRouteParams().appId;
    }

    /**
     * @override
     */
    submit(data) {
        if (this.pageType === 'create' && this.createRequester) {
            return this.requestCreate(data);
        }

        if (this.pageType === 'edit' && this.updateRequester) {
            return this.requestUpdate(data);
        }

        if (this.pageType === 'copy' && this.updateRequester) {
            return this.requestUpdate(data);
        }
        throw new Error(`unknown form page type: ${this.pageType}!`);
    }

    async requestAppList() {
        const appList = await this.getAppList({
            pageNo: 1,
            pageSize: 100
        });
        this.appListDatasource = map(appList.result, item => {
            return {
                value: item.id,
                label: item.name,
                aderName: item.aderName
            };
        });
    }

    async requestAderList() {
        const aderList = await this.getAderList();
        this.aderList = aderList.map(item => {
            return {
                value: item.id,
                label: item.name
            };
        });
    }

    /**
     * @override
     */
    prepareData(data) {
        const keys = this.formData.appId
            ? ['id', 'appId', 'name', 'submitType']
            : ['id', 'aderName', 'name', 'submitType'];
        return pick(data, keys);
    }

    /**
     * @override
     */
    adaptData(data) {
        // 当前页面可能是复制页，或者是 material 类型的ar，需要重置 crumbData
        this.isMaterial = get(data, 'serviceData.arTemplateType') !== 'AR_TEMPLATE_EDITOR';
        this.stepsInfo = this.getStepsData();
        return {
            appId: data.appId,
            tempType: get(data, 'serviceData.arTemplateType'),
            templateId: get(data, 'serviceData.templateId'),
            ...pick(data, ['name', 'status', 'id', 'appId'])
        };
    }

    getStepsData() {
        if (this.pageType === 'create' || this.isMaterial) {
            return {
                data: [
                    {
                        label: '填写基本信息'
                    },
                    {
                        label: '选择AR模板'
                    },
                    {
                        label: '配置AR物料'
                    },
                    {
                        label: '预览AR物料'
                    }
                ],
                current: 0
            };
        }
        return {
            data: [
                {
                    label: '填写基本信息'
                },
                {
                    label: '配置AR物料'
                },
                {
                    label: '预览AR物料'
                }
            ],
            current: 0
        };
    }

    setCrumbData() {
        if (this.pageType === 'edit') {
            this.crumbData[1].text = '编辑AR服务';
        }
        else if (this.pageType === 'copy') {
            this.crumbData[1].text = '复制AR服务';
        }

        this.crumbData[0].to = this.isAdmin ? '/service/reviewing/list' : '/app/service/list';
    }
}
